module.exports = __webpack_public_path__ + "img/BACKUP.5b9d6f60.svg";